import type { RootState } from 'features/app/store/store';
import { PreviousCallReportSource } from 'features/call/vrs-call-comments/enums';

export const isPreviousCallIdExistSelector = ({ vrsCallComments }: RootState) =>
  Boolean(vrsCallComments.previousCallId);

export const previousCallIdSelector = ({ vrsCallComments }: RootState) =>
  vrsCallComments.previousCallId;

export const isReportNeededSelector = ({ vrsCallComments }: RootState) =>
  vrsCallComments.isReportNeeded;

export const reportTypeSelector = ({ vrsCallComments }: RootState) =>
  vrsCallComments.reportType;

export const selectPreviousCallReportSource = ({
  vrsCallComments,
}: RootState) => vrsCallComments.previousCallReportSource;

// Legacy selectors for backward compatibility
export const selectIsPreviousCallReportStartedFromLobby = ({
  vrsCallComments,
}: RootState) =>
  vrsCallComments.previousCallReportSource === PreviousCallReportSource.LOBBY;

// Derived selector for any previous call mode
export const selectIsAnyPreviousCallMode = ({ vrsCallComments }: RootState) =>
  vrsCallComments.previousCallReportSource !== PreviousCallReportSource.NONE;

export const selectPreviousCalls = ({ vrsCallComments }: RootState) =>
  vrsCallComments.previousCalls;

export const selectIsLoadingPreviousCalls = ({ vrsCallComments }: RootState) =>
  vrsCallComments.isLoadingPreviousCalls;

export const selectPreviousCallBeingReportedId = ({
  vrsCallComments,
}: RootState) => vrsCallComments.reportingPreviousCallId;
